var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70725 0.29325C1.31625 -0.09775 0.68425 -0.09775 0.29325 0.29325C-0.09775 0.68425 -0.09775 1.31625 0.29325 1.70725L1.20025 2.61425C0.47725 3.16325 0.000250019 4.02325 0.000250019 5.00025V15.0003C0.000250019 16.6543 1.34625 18.0003 3.00025 18.0003H16.5863L18.2933 19.7073C18.4883 19.9023 18.7443 20.0003 19.0003 20.0003C19.2563 20.0003 19.5123 19.9023 19.7073 19.7073C20.0983 19.3163 20.0983 18.6843 19.7073 18.2933L1.70725 0.29325ZM4.05425 5.46825C3.41825 5.92225 3.00025 6.66125 3.00025 7.50025C3.00025 8.87925 4.12125 10.0003 5.50025 10.0003C6.33925 10.0003 7.07825 9.58225 7.53225 8.94625L9.58625 11.0003L8.00025 12.5863L7.12125 11.7073C5.95125 10.5373 4.04925 10.5373 2.87925 11.7073L2.00025 12.5863V5.00025C2.00025 4.57025 2.27425 4.21125 2.65525 4.06925L4.05425 5.46825Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H6L8 4H17C17.55 4 18 4.45 18 5V11.86L15.18 9.509C14.51 8.949 13.64 8.719 12.8 8.799L19.87 15.869C19.95 15.59 20 15.3 20 15V5C20 3.35 18.65 2 17 2Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.ada10d8f5b050751d4c6010348746d0b.svg";
export { ForwardRef as ReactComponent };